import ModalWizard from './modal_wizard'
import { connect } from 'react-redux'

import { fromVeniceSelector } from 'redux/selectors/venice'

const mapStateToProps = (state, { hideBack, hideClose, showIcon }) => {
  const fromVenice = fromVeniceSelector()(state)
  let hideTopWithoutHeader = false
  if (fromVenice) {
    hideBack = true
    hideClose = true
    showIcon = false
    hideTopWithoutHeader = true
  }

  return { hideBack, hideClose, showIcon, hideTopWithoutHeader }
}

export default connect(mapStateToProps)(ModalWizard)
